module.exports = __webpack_public_path__ + "static/media/SBPhotography_1-950w.bbb7f654.webp";